$dependencyManager.addDependencies(mad_dependencies);